// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Statistics cards wrapper */
.statistics-cards-wrapper {
  margin-bottom: 1.5rem;
}
.statistics-cards-wrapper .row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 1rem;
}

/* Compact card with zoom hover effect */
.stat-card-compact {
  background: #ffffff;
  border-radius: 18px !important;
  padding: 0.6rem 0.8rem !important;
  border: 2px solid transparent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 100%;
  cursor: pointer;
}
.stat-card-compact:hover {
  border-color: #88b6f2 !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transform: scale(1.05);
}
.stat-card-compact .stat-label-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.stat-card-compact .stat-label-wrapper .stat-dot {
  width: 8px !important;
  height: 8px !important;
  border-radius: 50%;
  margin-right: 6px !important;
  flex-shrink: 0;
}
.stat-card-compact .stat-label-wrapper .stat-label {
  font-size: 0.95rem !important;
  font-weight: 600 !important;
  line-height: 1.2;
  color: #000;
}
.stat-card-compact .stat-count {
  font-size: 1.2rem !important;
  font-weight: 800 !important;
  margin-left: 10px !important;
  color: #111827;
}

/* Ensuring Bootstrap row padding works */
.statistics-cards-wrapper .row > [class*=col-] {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-bottom: 1rem;
}

/* Stats box wrapper */
.stats-box {
  background: #f5f9ff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  margin-top: 10px;
}

/* Stats-row layout — Bootstrap handles 2 per row on mobile */
.stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 5px;
}

/* Desktop: 5 cards per row */
@media (min-width: 1200px) {
  .stats-row .col {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
/* MOBILE FIX (≤576px): Force 2 cards per row */
@media (max-width: 576px) {
  .stats-row {
    gap: 10px !important; /* smaller gap for mobile */
  }
  .stats-row .col {
    min-width: unset !important; /* remove 220px restriction */
    flex: 0 0 50% !important; /* 2 per row */
    max-width: 50% !important;
    padding: 0 !important;
  }
  .stat-card-compact {
    width: 100% !important;
    padding: 0.9rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Cards/component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,6BAAA;AACA;EACE,qBAAA;AAEF;AAAE;EACE,qBAAA;EACA,mBAAA;AAEJ;;AAEA,wCAAA;AACA;EACE,mBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,wCAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,gCAAA;EACA,mFAAA;EAEA,sBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AADJ;AAGI;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,cAAA;AADN;AAII;EACE,6BAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;AAFN;AAME;EACE,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,cAAA;AAJJ;;AAQA,yCAAA;AACA;EACE,qBAAA;EACA,sBAAA;EACA,oBAAA;AALF;;AAQA,sBAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;AALF;;AAQA,6DAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AALF;;AAaA,6BAAA;AACA;EACE;IACE,aAAA;IACA,cAAA;EAVF;AACF;AAaA,+CAAA;AACA;EAEE;IACE,oBAAA,EAAA,2BAAA;EAZF;EAeA;IACE,2BAAA,EAAA,6BAAA;IACA,wBAAA,EAAA,cAAA;IACA,yBAAA;IACA,qBAAA;EAbF;EAgBA;IACE,sBAAA;IACA,0BAAA;EAdF;AACF","sourcesContent":["/* Statistics cards wrapper */\n.statistics-cards-wrapper {\n  margin-bottom: 1.5rem;\n\n  .row {\n    --bs-gutter-x: 1.5rem;\n    --bs-gutter-y: 1rem;\n  }\n}\n\n/* Compact card with zoom hover effect */\n.stat-card-compact {\n  background: #ffffff;\n  border-radius: 18px !important;\n  padding: 0.6rem 0.8rem !important;\n  border: 2px solid transparent;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  height: 100%;\n  cursor: pointer;\n\n  &:hover {\n    border-color: #88b6f2 !important;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n      0 4px 6px -2px rgba(0, 0, 0, 0.05);\n    transform: scale(1.05);\n  }\n\n  .stat-label-wrapper {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.5rem;\n\n    .stat-dot {\n      width: 8px !important;\n      height: 8px !important;\n      border-radius: 50%;\n      margin-right: 6px !important;\n      flex-shrink: 0;\n    }\n\n    .stat-label {\n      font-size: 0.95rem !important;\n      font-weight: 600 !important;\n      line-height: 1.2;\n      color: #000;\n    }\n  }\n\n  .stat-count {\n    font-size: 1.2rem !important;\n    font-weight: 800 !important;\n    margin-left: 10px !important;\n    color: #111827;\n  }\n}\n\n/* Ensuring Bootstrap row padding works */\n.statistics-cards-wrapper .row > [class*=\"col-\"] {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  padding-bottom: 1rem;\n}\n\n/* Stats box wrapper */\n.stats-box {\n  background: #f5f9ff;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  margin-top: 10px;\n}\n\n/* Stats-row layout — Bootstrap handles 2 per row on mobile */\n.stats-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding-bottom: 5px;\n}\n\n// /* FIX: Desktop wide cards */\n// .stats-row .col {\n//   min-width: 220px !important;\n// }\n\n/* Desktop: 5 cards per row */\n@media (min-width: 1200px) {\n  .stats-row .col {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n}\n\n/* MOBILE FIX (≤576px): Force 2 cards per row */\n@media (max-width: 576px) {\n\n  .stats-row {\n    gap: 10px !important; /* smaller gap for mobile */\n  }\n\n  .stats-row .col {\n    min-width: unset !important; /* remove 220px restriction */\n    flex: 0 0 50% !important;    /* 2 per row */\n    max-width: 50% !important;\n    padding: 0 !important;\n  }\n\n  .stat-card-compact {\n    width: 100% !important;\n    padding: 0.9rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
